import React, { useContext, useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { DataContext } from '../../../js/App'
import { Button, Modal, Spinner } from 'react-bootstrap';
import './damageMarker.scss'
const DamageMarker = ({ name, fieldLabel, parentName }) => {
    const context = useContext(DataContext);
    const { damageData, handleChangeSelect, formValues, handleUpdateValue, handleMultipleValues, removeMultipleValues, dvlaClassFields } = context
    const [vehicleTypes, setVehicleTypes] = useState([]);
    const [vehicleAreas, setVehicleAreas] = useState([]);
    const [vehicleDamagePositions, setVehicleDamagePositions] = useState([]);
    const [vehicleDamageType, setVehicleDamageType] = useState([]);
    const [vehicleDamageDimensions, setVehicleDamageDimensions] = useState([]);
    const [damageMarkerRows, setDamageMarkerRows] = useState(0);
    const [selectedType, setSelectedType] = useState(null);
    const [modalToShow, setModalToShow] = useState(-1);
    const [modalsElements, setModalsElements] = useState([]);
    const [dvlaDefaultValue, setDvlaDefaultValue] = useState("");

    useEffect(() => {
        setDamageVariables();
        dvlaDefaultValueSet();
    }, [damageData]);

    useEffect(() => {
        dvlaDefaultValueSet();
    }, [dvlaClassFields]);

    const handleClose = () => {
        setModalToShow(-1);
    }

    const setDamageVariables = () => {
        if (damageData !== null) {
            const intVehicleTypes = [];
            damageData.forEach(damageType => {
                intVehicleTypes.push({ id: damageType.id, name: damageType.name })
            });
            setVehicleTypes(intVehicleTypes)
        }
    }
    const removeAllRows = () => {
        const rowsToRemove = damageMarkerRows;
        const valueToRemove = {};

        for (let i = 0; i < rowsToRemove; i++) {
            if (
                typeof formValues[name + '_area_' + i] !== 'undefined' &&
                formValues[name + '_area_' + i] !== '') {
                    valueToRemove[name + '_area_' + i] = '';
                    valueToRemove[name + '_position_' + i] = '';
                    valueToRemove[name + '_type_of_damage_' + i] = '';
                    valueToRemove[name + '_damage_dimension_' + i] = '';
            }
        }

        removeMultipleValues(valueToRemove);
        setModalsElements([]);
        setDamageMarkerRows(0);
    }

    const handleTypeSelected = (e) => {
        const selectedTypeObj = damageData.find(type => type.name === e.target.value);
        if(selectedType !== null && selectedType.name !== null && selectedTypeObj.name !== selectedType.name){
            removeAllRows();
        }
        setSelectedType(selectedTypeObj);
        setVehicleAreas(selectedTypeObj.options);
        setDvlaDefaultValue(e.target.value);
        handleChangeSelect(e, false);
    }

    const handleTypeSelectedByDvla = (dvlaType) => {
        if(damageData !== null){
            const selectedTypeObj = damageData.find(type => type.name === dvlaType);
            if(selectedTypeObj){
                setSelectedType(selectedTypeObj);
                setVehicleAreas(selectedTypeObj.options);
                if(selectedType !== null && selectedType.name !== null && selectedTypeObj.name !== selectedType.name){
                    removeAllRows();
                }
            }
        }
    }

    const handleAreaSelected = (e, index) => {
        const valueToUpdate = {};
        const selectedAreaObj = vehicleAreas.find(area => area.name === e.target.value);
        valueToUpdate[name + '_position_' + index] = '';
        valueToUpdate[name + '_type_of_damage_' + index] = '';
        valueToUpdate[name + '_damage_dimension_' + index] = '';

        handleMultipleValues(valueToUpdate);
        setVehicleDamagePositions(selectedAreaObj.options);
        setVehicleDamageType([]);
        setVehicleDamageDimensions([]);
        handleChangeSelect(e, false);
    }

    const handlePositionSelected = (e, index) => {
        const valueToUpdate = {};
        const selectedPositionObj = vehicleDamagePositions.find(position => position.name === e.target.value);
        valueToUpdate[name + '_type_of_damage_' + index] = '';
        valueToUpdate[name + '_damage_dimension_' + index] = '';

        handleMultipleValues(valueToUpdate);

        setVehicleDamageType(selectedPositionObj.options);
        setVehicleDamageDimensions([]);
        handleChangeSelect(e, false);
    }

    const handleDamageTypeSelected = (e, index) => {
        const valueToUpdate = {};
        const selectedDamageTypeObj = vehicleDamageType.find(damageType => damageType.name === e.target.value);
        valueToUpdate[name + '_damage_dimension_' + index] = '';

        handleMultipleValues(valueToUpdate);

        setVehicleDamageDimensions(selectedDamageTypeObj.dimension);
        handleChangeSelect(e, false);
    }

    const handleDamageDimensionSelected = (e, index) => {
        handleChangeSelect(e, false);
    }

    const handleDamageMarkerModification = (index) => {
        let selectedAreaObj = [];
        let selectedPositionObj = [];
        let selectedDamageTypeObj = [];
        let selectedDamageDimensionObj = [];

        if (typeof formValues[name + "_area_" + index] !== 'undefined' && formValues[name + "_area_" + index] !== '') {
            selectedAreaObj = vehicleAreas.find(area => area.name === formValues[name + "_area_" + index]);
            selectedPositionObj = selectedAreaObj.options;
            setVehicleDamagePositions(selectedPositionObj);
        } else {
            setVehicleDamagePositions([]);
        }

        if (typeof formValues[name + "_position_" + index] !== 'undefined' && formValues[name + "_position_" + index] !== '') {
            selectedDamageTypeObj = selectedPositionObj.find(position => position.name === formValues[name + "_position_" + index]);
            selectedDamageTypeObj = selectedDamageTypeObj.options;

            setVehicleDamageType(selectedDamageTypeObj);
        } else {
            setVehicleDamageType([]);
        }

        if (typeof formValues[name + "_type_of_damage_" + index] !== 'undefined' && formValues[name + "_type_of_damage_" + index] !== '') {
            selectedDamageDimensionObj = selectedDamageTypeObj.find(typeOfDamage => typeOfDamage.name === formValues[name + "_type_of_damage_" + index]);
            selectedDamageDimensionObj = selectedDamageDimensionObj.dimension;

            setVehicleDamageDimensions(selectedDamageDimensionObj);
        } else {
            setVehicleDamageDimensions([]);
        }

        setModalToShow(index);
    }

    const checkModalToShow = (actualModalIndex) => {
        if ((modalToShow) === actualModalIndex) return true;
        else return false;
    }

    const addRow = () => {
        const tmpModalElements = modalsElements;
        tmpModalElements.push({});

        setModalsElements(tmpModalElements);
        setModalToShow(damageMarkerRows);
        setDamageMarkerRows(damageMarkerRows + 1);
    }

    const removeRow = index => {
        const tmpModalElements = modalsElements;
        const originalIndex = index;

        let valueToRemove = {};
        valueToRemove[name + '_area_' + index] = '';
        valueToRemove[name + '_position_' + index] = '';
        valueToRemove[name + '_type_of_damage_' + index] = '';
        valueToRemove[name + '_damage_dimension_' + index] = '';

        removeMultipleValues(valueToRemove);

        const valueToUpdate = {};
        while (tmpModalElements.length > index) {
            if (
                typeof formValues[name + '_area_' + (index + 1)] !== 'undefined' &&
                formValues[name + '_area_' + (index + 1)] !== '') {
                valueToUpdate[name + '_area_' + index] = formValues[name + '_area_' + (index + 1)];
                valueToUpdate[name + '_position_' + index] = formValues[name + '_position_' + (index + 1)];
                valueToUpdate[name + '_type_of_damage_' + index] = formValues[name + '_type_of_damage_' + (index + 1)];
                valueToUpdate[name + '_damage_dimension_' + index] = formValues[name + '_damage_dimension_' + (index + 1)];
            }
            index++;
        }
        handleMultipleValues(valueToUpdate);

        valueToRemove = {};
        valueToRemove[name + '_area_' + (index - 1)] = '';
        valueToRemove[name + '_position_' + (index - 1)] = '';
        valueToRemove[name + '_type_of_damage_' + (index - 1)] = '';
        valueToRemove[name + '_damage_dimension_' + (index - 1)] = '';

        removeMultipleValues(valueToRemove);

        tmpModalElements.splice(0, 1);

        setModalsElements(tmpModalElements);
        setDamageMarkerRows(damageMarkerRows - 1);
        handleClose();
    }
    
    const dvlaDefaultValueSet = () => {
        if(damageData !== null){
            const dvlaType = dvlaClassFields[parentName !== "" ? parentName : "dvlaClass"];
            if(typeof dvlaType !== 'undefined' && 
            formValues[name + "_type"] !== dvlaType){
                handleUpdateValue(name + "_type", dvlaType);
                if(dvlaDefaultValue !== dvlaType){
                    if(
                        typeof damageData !== 'undefined' &&
                        damageData.find(type => type.name === dvlaType)
                    ){
                        setDvlaDefaultValue(dvlaType);
                    }
                    handleTypeSelectedByDvla(dvlaType);
                }
            }
        }
    }

    dvlaDefaultValueSet();
    return (
        <Form.Group as={Row} className="mb-3" controlId="damageMarker">
            <Form.Label column xs="12">
                {fieldLabel}
            </Form.Label>
            <Col xs="12" className="inlineOptions">
                {damageData === null && (<Spinner animation="border" variant="primary" />)}
                {damageData !== null && (<>
                    {damageData === [] && ("There was a problem by loading the damage data")}
                    {damageData !== [] && (<>
                        <Form.Group as={Row} className="mb-3" controlId="damageMarkerDropdownSelect">
                            <Col xs="12">
                                <Form.Select value={dvlaDefaultValue} name={name + "_type"} onChange={(e) => handleTypeSelected(e)}>
                                    <option key={-1}>Please select...</option>
                                    {vehicleTypes.map((option, index) => (
                                        <option key={index} value={option.name} data-id={option.id}>{option.name}</option>
                                    ))}
                                </Form.Select>
                            </Col>
                        </Form.Group>
                    </>)}
                </>
                )}
            </Col>
                <Col xs="12">
                    <Row className='justify-content-center'>
                    {modalsElements.map((element, index) => (<>
                        <Col className='mt-3' xs="12" md="6" xxl="4">
                            <Button className='btnDamage' variant="outline-primary" onClick={() => handleDamageMarkerModification(index)}>
                                <div className='buttonText'>{'Modify Damage Description N.' + (index + 1)}</div>
                                <div className='damageName'>
                                    {typeof formValues[name + "_area_" + index] !== 'undefined' ? formValues[name + "_area_" + index] : ''}&nbsp;
                                    {typeof formValues[name + "_position_" + index] !== 'undefined' ? formValues[name + "_position_" + index] : ''}
                                </div>
                            </Button>
                        </Col>
                        <Modal key={name + "_modals_" + index} show={checkModalToShow(index)} onHide={handleClose} centered>
                            <Modal.Header closeButton>
                                <Modal.Title>Damage marker N. {index + 1}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form.Group as={Row} className="mb-3" controlId="damageAreaDropdownSelect">
                                    <Form.Label column xs="12">
                                        Damage Area
                                    </Form.Label>
                                    <Col xs="12">
                                        <Form.Select defaultValue={typeof formValues[name + "_area_" + index] !== 'undefined' ? formValues[name + "_area_" + index] : ''} name={name + "_area_" + index} onChange={(e) => handleAreaSelected(e, index)}>
                                            <option key={-1}>Please select...</option>
                                            {vehicleAreas.map((option, index) => (
                                                <option key={index} value={option.name} data-id={option.id}>{option.name}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="damagePositionDropdownSelect">
                                    <Form.Label column xs="12">
                                        Damage Position
                                    </Form.Label>
                                    <Col xs="12">
                                        <Form.Select defaultValue={typeof formValues[name + "_position_" + index] !== 'undefined' ? formValues[name + "_position_" + index] : ''} name={name + "_position_" + index} onChange={(e) => handlePositionSelected(e, index)}>
                                            <option key={-1}>Please select...</option>
                                            {vehicleDamagePositions.map((option, index) => (
                                                <option key={index} value={option.name} data-id={option.id}>{option.name}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="damagePositionDropdownSelect">
                                    <Form.Label column xs="12">
                                        Damage Type
                                    </Form.Label>
                                    <Col xs="12">
                                        <Form.Select defaultValue={typeof formValues[name + "_type_of_damage_" + index] !== 'undefined' ? formValues[name + "_type_of_damage_" + index] : ''} name={name + "_type_of_damage_" + index} onChange={(e) => handleDamageTypeSelected(e, index)}>
                                            <option key={-1}>Please select...</option>
                                            {vehicleDamageType.map((option, index) => (
                                                <option key={index} value={option.name} data-id={option.id}>{option.name}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="damagePositionDropdownSelect">
                                    <Form.Label column xs="12">
                                        Damage Dimension
                                    </Form.Label>
                                    <Col xs="12">
                                        <Form.Select defaultValue={typeof formValues[name + "_damage_dimension_" + index] !== 'undefined' ? formValues[name + "_damage_dimension_" + index] : ''} name={name + "_damage_dimension_" + index} onChange={(e) => handleDamageDimensionSelected(e, index)}>
                                            <option key={-1}>Please select...</option>
                                            {vehicleDamageDimensions.map((option, index) => (
                                                <option key={index} value={option.name} data-id={option.id}>{option.name}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="primary" onClick={handleClose}>
                                    Save Changes
                                </Button>
                                <Button variant="danger" onClick={() => removeRow(index)}>
                                    Remove
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </>
                    ))}
                    <Col className='mt-3 text-center' xs="12">
                        {selectedType !== null && (
                            <Button variant="primary" onClick={() => addRow()}>{damageMarkerRows === 0 ? 'Add The First Damage Description' : 'Add New Damage Description'}</Button>
                        )}
                    </Col>
            </Row>
        </Col>
        </Form.Group >
    )
}

export default DamageMarker;
